import * as Yup from 'yup'

export const specialLoyaltyRefundTxSchemas = Yup.object().shape({
  externalTransactionId: Yup.number().required(),
  ident: Yup.string().required(),
  loyaltyValue: Yup.number().required(),
  storeId: Yup.number(),
  deviceCode: Yup.string().optional(),
  cashier: Yup.string().optional(),
  guid: Yup.string().optional(),
  comments: Yup.string().optional(),
  traceNumber: Yup.number().optional(),
  reasonId: Yup.number().optional(),
})